/** Width is measured on the visible text, so colour never breaks alignment. */
export function stripAnsi(text: string): string {
  return text.replace(/\u001b\[\d+m/g, "");
}
